import React from 'react';
import { useTranslation } from 'react-i18next';
import { organizationAPI } from '../../services/api';
import { StoreTheme, normalizeTheme } from '../../utils/storeTheme';
import ThemeSettingsSection from './ThemeSettingsSection';

/**
 * Κεντρικά → Ρυθμίσεις → «Εμφάνιση»: η προεπιλογή όλων των καταστημάτων του οργανισμού
 * (PUT /api/organizations/:orgId/theme, migration 263). Κάθε κατάστημα την αλλάζει ανά πεδίο από τις
 * δικές του Ρυθμίσεις (Κατάστημα → «Εμφάνιση», useStoreThemeForm). Τα κεντρικά δεν είναι κατάστημα: το θέμα
 * ΔΕΝ εφαρμόζεται εδώ. Εδώ η αυτόνομη μορφή του ThemeSettingsSection, με δικό της «Αποθήκευση».
 */
const OrgThemeSettings: React.FC<{
  orgId: number;
  value: StoreTheme | null;
  onSaved?: (theme: StoreTheme | null) => void;
  storeName?: string;
}> = ({ orgId, value, onSaved, storeName }) => {
  const { t } = useTranslation(['settings']);
  const onSave = async (next: StoreTheme | null) => {
    try {
      const data = await organizationAPI.updateTheme(orgId, next);
      const saved = normalizeTheme(data?.theme);
      onSaved?.(saved);
      return saved;
    } catch (err: any) {
      throw new Error(err?.response?.data?.error || err?.response?.data?.message || t('settings:theme.saveError'));
    }
  };
  return <ThemeSettingsSection scope="org" value={value} onSave={onSave} variant="embedded" storeName={storeName} />;
};

export default OrgThemeSettings;
